const MAIN_STEP_1 = 'asset-inventory-main-driver-step-1'
const MAIN_STEP_2 = 'asset-inventory-main-driver-step-2'
const MAIN_STEP_3 = 'asset-inventory-main-driver-step-3'

const MAIN_STEPS_OBJECT = [
  {
    element: '#' + MAIN_STEP_1,
    popover: {
      description:
        'O inventário de ativos registra e organiza os <strong>recursos de TI</strong> utilizados para processar e ' +
        'armazenar dados, como sistemas, aplicações, servidores, dispositivos e serviços em nuvem. <br />' +
        'Mantenha informações sobre <strong>localização, responsáveis, licenciamento e manutenção</strong> para ' +
        'apoiar a segurança da informação, o suporte técnico e a conformidade regulatória. <br />' +
        'O objetivo é garantir o <strong>controle do ciclo de vida</strong> dos ativos da organização.',
    },
  },
  {
    element: '#' + MAIN_STEP_2,
    popover: {
      description: 'Cadastre um novo inventário aqui.',
    },
  },
  {
    element: '#' + MAIN_STEP_3,
    popover: {
      description:
        'Na tabela, são exibidas as principais informações dos ativos cadastrados para facilitar a ' +
        'visualização, como nome e categoria. Caso precise localizar um inventário específico, utilize ' +
        'o filtro de busca.',
    },
  },
]

const MANAGE_STEP_1 = 'asset-inventory-manage-driver-step-1'
const MANAGE_STEP_2 = 'asset-inventory-manage-driver-step-2'
const MANAGE_STEP_3 = 'asset-inventory-manage-driver-step-3'

const MANAGE_STEPS_OBJECT = [
  {
    element: '#' + MANAGE_STEP_1,
    popover: {
      description:
        'Esta é a tela de cadastro do Inventário de Ativos. O inventário de ativos é fundamental para identificar ' +
        'quais dispositivos e recursos a empresa possui, além de apoiar a gestão e a segurança desses ativos.',
    },
  },
  {
    element: '#' + MANAGE_STEP_2,
    popover: {
      description:
        'Para realizar o cadastro, é necessário informar o nome do ativo, selecionar a categoria à qual ele ' +
        'pertence e adicionar uma descrição. Após a escolha da categoria, o sistema exibirá campos adicionais ' +
        'relevantes para complementar as informações do ativo.',
    },
  },
  {
    element: '#' + MANAGE_STEP_3,
    popover: {
      description:
        'As informações adicionais permitem identificar com precisão qual é o dispositivo cadastrado, evitando ' +
        'registros genéricos ou abrangentes demais. Dessa forma, o inventário fica mais organizado, claro e ' +
        'confiável, garantindo que cada ativo represente exatamente o recurso correspondente.',
    },
  },
]

export default {
  MAIN_STEPS_OBJECT,
  MAIN_STEP_1,
  MAIN_STEP_2,
  MAIN_STEP_3,
  MANAGE_STEPS_OBJECT,
  MANAGE_STEP_1,
  MANAGE_STEP_2,
  MANAGE_STEP_3,
}
